// DragDropPortal.js
import { createPortal } from 'react-dom';

export function DraggablePortal({ children }) {
  return createPortal(children, document.body);
}
